import React from 'react';
import { Switch, Route } from 'react-router';
import DocumentTitle from 'react-document-title';
import Company from './Company';
import Invoices from './Invoices';
import Orders from './Orders';


const Profile = ({ match }) => (
  <div>
    <DocumentTitle title="Profils - e-BML" />
    <Switch>
      <Route path={`${match.url}/company/`} component={Company}/>
      <Route path={`${match.url}/invoices/`} component={Invoices}/>
      <Route path={`${match.url}/orders/`} component={Orders}/>
    </Switch>
  </div>
);

export default Profile;


// WEBPACK FOOTER //
// ./src/scenes/Profile/index.js